import { QueryClient } from "@tanstack/react-query";

// QueryClient singleton exportado para uso em contextos onde o hook não está disponível
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos - dados considerados "fresh"
      gcTime: 10 * 60 * 1000, // 10 minutos - tempo antes de limpar cache
      retry: 1, // Tentar apenas 1 vez em caso de falha
      refetchOnWindowFocus: false, // Não refetch ao focar janela
    },
  },
});
